import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";
import {
  BreakPointTablet,
  BreakPointMobile,
  BreakPointDesktop,
} from "../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    width: "100%",
    minHeight: "100dvh",
    display: "flex",
    position: "relative",
    boxSizing: "border-box",
    flexDirection: "column",
    [BreakPointTablet]: {
      paddingTop: 100,
    },
    [BreakPointMobile]: {
      paddingTop: 70,
      position: "fixed",
      inset: 0,
      overflowY: "auto",
      overscrollBehavior: "contain",
    },
  },
  logo: {
    width: 80,
    [BreakPointDesktop]: {
      width: 120,
    },
  },
  backgroundImage: {
    height: "100dvh",
    width: "100vw",
    position: "fixed",
    objectFit: "cover",
    zIndex: 0,
    top: 0,
    left: 0,
  },
  header: {
    padding: theme.spacing.space16,
    position: "absolute",
    top: 0,
    left: 0,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space48,
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    zIndex: 1,
    [BreakPointTablet]: {
      padding: `${theme.spacing.space24}px 80px`,
    },
    [BreakPointDesktop]: {
      padding: `${theme.spacing.space32}px ${theme.spacing.space16}px`,
      paddingBottom: theme.spacing.space48,
      width: 600,
      borderRadius: theme.radius.large,
      background: "rgba(0, 0, 0, 0.4)",
      position: "absolute",
      transform: "translate(-50%, -50%)",
      top: "50%",
      left: "50%",
    },
  },
  titleContent: {
    zIndex: 1,
    textAlign: "center",
  },
  usernameInputContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  warning: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.space8,
    gap: theme.spacing.space4,
    paddingLeft: theme.spacing.space8,
  },
  warningIcon: {
    color: theme.colors.NotificationError,
    flexShrink: 0,
  },
  avatarContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 20,
    [BreakPointTablet]: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
    },
    [BreakPointDesktop]: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      padding: `0 ${theme.spacing.space32}px`,
    },
  },
  avatar: {
    width: 100,
    height: 100,
    borderRadius: "50%",
  },
  avatarWrapper: {
    borderRadius: "50%",
    width: 100,
    height: 100,
    position: "relative",
    "&.active": {
      boxShadow: "0 0 0 3px #1877EB",
    },
  },
  active: {
    boxShadow: "inset 0 0 0 2px #1877EB, 0 0 0 1px #1877EB",
  },
  checkIcon: {
    position: "absolute",
    color: "#1877EB",
    background: "#fff",
    borderRadius: "50%",
    top: 2,
    right: 2,
    boxShadow: "inset 0 0 0 3px #1877EB, 0 0 0 1px #1877EB",
  },
}));
